export default {
  fields: {
    demo: {
      label: 'Crear demo',
    },
    ai: {
      label: 'Optimizado con IA',
    },
    restaurant_type: {
      label: 'Selecciona el tipo de restaurante',
      types: {
        Pizza: 'Pizza 🍕',
        PizzaDelivery: 'Entrega de pizza 🍕🚗',
        PizzaNeapolitan: 'Pizza napolitana 🍕',
        Italian: 'Italiano 🇮🇹',
        Burger: 'Hamburguesa 🍔',
        Turkish: 'Turco 🇹🇷',
        Mexican: 'Mexicano 🌮',
        Sushi: 'Sushi 🍱',
        Japanese: 'Japonés 🇯🇵',
        Vietnamese: 'Vietnamita 🇻🇳',
        Thai: 'Tailandés 🇹🇭',
        Asian: 'Asiático 🍜',
        Indian: 'Indio 🥘',
        Bowls: 'Bowls 🥣',
        Vegan: 'Vegano 🥑',
        Greek: 'Griego 🏛️',
        Cafe: 'Café ☕️',
        Brunch: 'Brunch 🍵',
        Oriental: 'Oriental / Oriente Medio 🧆',
        Spanish: 'Español / Tapas 🇪🇸',
        Persian: 'Persa 🫖',
      },
    },
    plugins: {
      reservations: 'Reservas',
      reservations_plan_hint:
        'Las reservas requieren un Plan Partner. Se te pedirá activarlo para {{name}} al crear el sitio web.',
      catering: 'Catering',
      events: 'Eventos',
    },
    quarter: {
      label: 'Barrio',
      address_placeholder: 'Introduce la dirección',
      quarter_placeholder: 'Introduce el barrio',
    },
    delivery_areas: {
      label: '¿Qué zonas de la ciudad atiendes?',
      city_placeholder: 'Introduce la ciudad',
      district_placeholder: 'Barrio 1, Barrio 2, Barrio 3',
    },
    best_dishes: {
      label: '¿Cuáles son tus 3 platos estrella?',
      placeholder: 'Introduce platos (Hamburguesa de pollo, Hamburguesa de queso, etc.)',
    },
    dietary_attributes: {
      label: '¿Tienes opciones para personas que quieren comer:',
      placeholder: 'Selecciona las preferencias dietéticas',
      types: {
        vegetarian: 'Vegetariano',
        vegan: 'Vegano',
        halal: 'Halal',
        gluten_free: 'Sin gluten',
        dairy_free: 'Sin lácteos',
        spicy: 'Picante',
      },
    },
    family_owned: {
      label: '¿Negocio familiar?',
      yes: 'Sí',
      no: 'No',
    },
    business_founding_year: {
      label: '¿En qué año abrió el restaurante?',
    },
    business_owners: {
      label: 'Propietarios',
      placeholder: 'Introduce el propietario',
    },
    notes: {
      label: 'Añadir notas adicionales (opcional)',
      placeholder: 'Ejemplo: restaurante orientado a la comunidad, iniciativas, de pareja...',
    },
    about_us: {
      title: 'Sobre nosotros (Vista previa)',
    },
  },
  sections: {
    plugins: 'Plugins',
    company_info: 'Generar información de empresa',
  },
  buttons: {
    find_district: 'Buscar barrio',
    generate: 'Generar',
    products: 'Productos',
    add: 'Añadir',
  },
};
